import Availability from '@app/components/common/Availability';

export const getAvailability = (
  { sourcingDetails, availability, hoseAssemblyIndicator },
  isStoreAvailabilityEnabled,
  hoseAvailabilityLabel,
  sourcingToggle
) => {
  const hoseAssemblyDetails = {
    hoseAvailabilityLabel: hoseAvailabilityLabel,
    hoseAssemblyIndicator: hoseAssemblyIndicator
  };

  return (
    <Availability
      availabilityInformation={
        isStoreAvailabilityEnabled
          ? sourcingDetails?.availabilityByDate
          : availability
      }
      sourcingDetailsInformation={sourcingDetails?.availabilityBySource}
      availabilityTypeShowToggle={sourcingToggle}
      hideLabel
      hoseAssemblyDetails={hoseAssemblyDetails}
      storeAvailability={sourcingDetails?.storeAvailability}
    />
  );
};
